import React from "react";
import "./footer.css";
import Image from "../../Pyragon/PyraGon.png";

import Twitter from "../../Pyragon/twitter.png";
import Email from "../../Pyragon/discord.png";
import TeleGeam from "../../Pyragon/telegram.png";
import Bitcoin from "../../Pyragon/medium.png";

const Footer = () => {
  return (
    <footer>
      <div className="container-footer" id="container-footer">
        <div id="heading-footer-second-container-1">
          <div className="logo">

          <span>
            {" "}
            <img src={Image} style={{ width: "40px", height: "40px" }} />{" "}
          </span>
          <span id="PYRA-heading">PYRAGON</span>
          </div>
          <h6 style={{ color: "rgb(156, 147, 147)", fontSize: "15px", cursor: "pointer" }}>
            &copy; Copyright PYRAGON. All Rights Reserved
          </h6>
        </div>
        <div id="heading-footer-second-container-2">
          <div className="heading-footer">
            <h2>Important Links</h2>
            <h3>
              <a href="">PancakeSwap </a>
            </h3>
            <h3>
              <a href="">CoinGecko </a>
            </h3>
            <h3>
              <a href="#work-main-container">CoinMarketCap </a>
            </h3>
            <h3>
              <a href="#roadmap-main-container">Liquidity Locks </a>
            </h3>
              <h3>
              <a href="#roadmap-main-container">Documentation</a>
            </h3>            
            <h3>
              <a href="#roadmap-main-container">Github</a>
            </h3>
          </div>
          <div className="card-footer">
            <h2>
              Information 
            </h2>
            <h3>
              <a href="https://t.me/pyragonio">Join Telegram</a>
            </h3>
            <h3>
              <a href="https://twitter.com/pyragonio?s=21">Follow Twitter</a>
            </h3>
            <h3>
              <a href="https://discord.gg/maEb3zVU">Join Discord </a>
            </h3>
            <div id="card-footer-icons">
              <a href="https://t.me/pyragonio" class="social-link-mobile">
                <img src={TeleGeam} style={{ width: "20px", height: "20px" }} />
              </a>
              <a href="https://twitter.com/pyragonio?s=21" class="social-link-mobile">
                <img src={Twitter} style={{ width: "20px", height: "20px" }} />
              </a>
              <a href="https://discord.gg/maEb3zVU" class="social-link-mobile">
                <img src={Email} style={{ width: "25px", height: "25px" }} />
              </a>
              <a class="socail-link-mobile">
                <img
                  alt="first"
                  src={Bitcoin}
                  style={{ width: "20px", height: "20px" }}
                />
              </a>
            </div>
          </div>
          <div className="footer--contact--info">
            <h3>Contact us with any questions</h3>
            <h3>info@pyragon.io</h3>
            <h3>FAQ</h3>
            <h3>Privacy Policy</h3>
            <h3>Terms and Conditions</h3>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
